module.exports = __webpack_public_path__ + "img/accuracy.55ae048d.svg";